import React, { Component } from 'react';

class GameButton extends React.Component {

  render() {
    var buttonStyle = this.props.colorClass;
    if (this.props.illuminated){
      buttonStyle += " illuminated-" + this.props.color;
    }
    return (
        <div className={buttonStyle} onClick={this.props.playButton}></div>
    );
  }
}
export default GameButton;


// WEBPACK FOOTER //
// ./src/GameButton.js